import { APP_INITIALIZER, NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthentificationModule } from './authentification/authentification.module';
import { CoreModule } from './core/core.module';
import { MainModule } from './main/main.module';
import { NgbDateMomentParserFormatter } from './shared/services/ngb-date-parser-Formatter/ngb-date-parser-formatter.service';
import { NgxEchartsModule } from 'ngx-echarts';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { DataModule } from './data/data.module';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { VinPreset } from '../assets/themes/vin.preset';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEn, 'en');

// Cette factory sera exécutée AVANT la création de l'app.
// Donc TranslateService.currentLang sera déjà 'fr' si navigateur FR.
export function appInitFactory(translate: TranslateService) {
    return () => {
        const DEFAULT_LANG = 'fr';

        translate.addLangs(['fr', 'en']);
        translate.setDefaultLang(DEFAULT_LANG);

        // on force FR au démarrage
        translate.use(DEFAULT_LANG);
    };
}

export class DynamicLocaleId extends String {
    constructor(protected service: TranslateService) {
        super('');
    }

    toString() {
        const lang = (this.service.currentLang || '').toLowerCase();

        if (lang.startsWith('fr')) {
            return 'fr'; // on a enregistré 'fr'
        }
        if (lang.startsWith('en')) {
            return 'en'; // on a enregistré 'en'
        }

        // fallback
        return 'fr';
    }
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        CoreModule,
        MainModule,
        AuthentificationModule,
        AppRoutingModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts')
        }),
        FontAwesomeModule,
        ReactiveFormsModule,
        SharedModule,
        TranslateModule,
        DataModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: appInitFactory,
            deps: [TranslateService],
            multi: true
        },
        { provide: LOCALE_ID, useClass: DynamicLocaleId, deps: [TranslateService] },
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateMomentParserFormatter,
            deps: [TranslateService]
        },
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: VinPreset,
                options: {
                    darkMode: true
                }
            },
            translation: {
                selectionMessage: '{0} éléments sélectionnés'
            }
        })
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
